<template>
    <div class="vid-component mb-3">             
        <v-layout wrap row>
            <v-flex xs12 sm4 v-for="(vid, index) in videos" :key="index">

                <a data-fancybox="performances" data-type="iframe" :href="vid.url">
                    <p class="border-right-white">{{vid.name}}</p>
                    <div>
                        <img :src="vid.thumb" :alt="vid.name" class="img-fluid"> 
                    </div>
                </a>
            </v-flex>           
        </v-layout>
    </div>
</template>

<script>
    export default {
        props: ['videos'],
        data: () => ({
           
        })
    }
</script>
<style>
    .vid-component a {
       text-decoration: none; 
    }
    .border-right-white {
        border-right: 1px solid #fff!important;
        padding: 0 5px;
    }
</style>
